var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',{staticClass:"font-size-sm",attrs:{"to":{ name: _vm.path, params: { id: _vm.reference.id } }}},[_vm._v(" "+_vm._s(_vm.displayLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }